<script>
  import Card from "../components/Card.svelte";

  export let title = 'Curbza Enterprise';
  export let subtitle = 'Monetize Excess Items and Assets';
  export let leadParagraph = 'Users will access deals more effeciently, and your ' +
    'offerings will be featured with more prominence<br>providing your members with better and value.'
  export let callToAction = 'Read more on Curbza Enterprise';
  const DEFAULT_IMAGE = '//via.placeholder.com/132x132/0B60BE/FFFFFF?text=%20';
  export let cards = [
    {
      featuredImage: '../../assets/images/icons/ent-scalable-icon.svg',
      title: 'Scalable',
      text: 'Whether your needs are big or small, our system scales to match your growing demands.'
    },
    {
      featuredImage: '../../assets/images/icons/ent-module-based-icon.svg',
      title: 'Module-Based',
      text: 'Any specific functionality you need is fitted into individual modules, so you can keep out the bloat.'
    },
    {
      featuredImage: '../../assets/images/icons/ent-high-availability-icon.svg',
      title: 'High Availablity',
      text: 'Our system is optimized to ensure that your marketplaces enjoy up to 99% uptime at peak performance.'
    },
  ];
</script>

<style>
  #enterprise {
    margin: 0;
    height: 908px;
    background-color: var(--panel);
    color: var(--panel-text);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #enterprise .row {
    align-items: flex-start;
  }

  .img-container {
    position: relative;
    /* border-radius: 50%; */
    overflow: hidden;
    width: 132px;
    height: 132px;
  }

  .img-container img {
    position: absolute;
    color: var(--primary);
  }

  .heading, .lead-paragraph {
    font-family: 'Open Sans Light', Arial, Helvetica, sans-serif !important;
    text-align: center;
  }

  a {
    font-size: 36px;
    text-decoration: underline;
    color: var(--primary);
  }

  /* Small devices (landscape phones, 767px and up) */
  @media (max-width: 767px) {
    #enterprise {
      height: auto;
      padding: 4vw 2vw;
    }

    #enterprise .row {
      flex-direction: column;
      align-items: center;
    }

    #enterprise .lead-paragraph {
      padding: 0 1vw;
    }

    #enterprise .lead-paragraph + a {
      text-align: center;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {

  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
  }

  /* Super large devices (large desktops, 1400px and up) */
  @media (min-width: 1400px) {
  }
</style>

<main id="enterprise">
  <h1 class="title">{title}</h1>
  <h3 class="subtitle margin-bottom-2vw">{subtitle}</h3>

  <div class="row row-centered">
    {#each cards as card}
    <Card>
      <div class="img-container">
        <img src={card.featuredImage} alt={card.title}>
      </div>
      <h4 class="heading">{card.title}</h4>
      <p class="lead-paragraph">{card.text}</p>
    </Card>
    {/each}
  </div>

  <p class="lead-paragraph margin-top-4vw">{@html leadParagraph}</p>
  <a href="/about-curbza-enterprise">{callToAction}</a>
</main>